export default __webpack_public_path__ + "images/43_thumbnail.jpg";